"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var classnames_1 = __importDefault(require("classnames"));
var interfaceScale_1 = require("stremio/common/interfaceScale");
var ActionMenu_less_1 = __importDefault(require("./ActionMenu.less"));
var VIEWPORT_PADDING = 8;
var HIDDEN_MENU_STYLE = { visibility: 'hidden' };
var ActionMenu = function (_a) {
    var _b, _c;
    var className = _a.className, title = _a.title, tabIndex = _a.tabIndex, options = _a.options, children = _a.children, onOpen = _a.onOpen, onClose = _a.onClose, onSelect = _a.onSelect;
    var triggerRef = (0, react_1.useRef)(null);
    var menuRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(false), open = _d[0], setOpen = _d[1];
    var _e = (0, react_1.useState)(null), position = _e[0], setPosition = _e[1];
    var openMenu = (0, react_1.useCallback)(function () {
        setOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [onOpen]);
    var closeMenu = (0, react_1.useCallback)(function () {
        setOpen(false);
        setPosition(null);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    var closeMenuAndRestoreFocus = (0, react_1.useCallback)(function () {
        var _a;
        closeMenu();
        (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [closeMenu]);
    (0, react_1.useLayoutEffect)(function () {
        var _a;
        if (!open || !triggerRef.current || !menuRef.current)
            return;
        var triggerRect = (0, interfaceScale_1.getInterfaceRect)(triggerRef.current);
        var menuRect = (0, interfaceScale_1.getInterfaceRect)(menuRef.current);
        var viewportWidth = window.innerWidth / (0, interfaceScale_1.getInterfaceScale)();
        var viewportHeight = window.innerHeight / (0, interfaceScale_1.getInterfaceScale)();
        var maxTop = viewportHeight - menuRect.height - VIEWPORT_PADDING;
        var maxLeft = viewportWidth - menuRect.width - VIEWPORT_PADDING;
        var preferredTop = triggerRect.bottom + menuRect.height <= viewportHeight - VIEWPORT_PADDING
            ? triggerRect.bottom
            : triggerRect.top - menuRect.height;
        var preferredLeft = triggerRect.left + menuRect.width <= viewportWidth - VIEWPORT_PADDING
            ? triggerRect.left
            : triggerRect.right - menuRect.width;
        setPosition({
            top: Math.max(VIEWPORT_PADDING, Math.min(preferredTop, maxTop)),
            left: Math.max(VIEWPORT_PADDING, Math.min(preferredLeft, maxLeft))
        });
        (_a = menuRef.current.querySelector('[role="menuitem"]')) === null || _a === void 0 ? void 0 : _a.focus();
    }, [open]);
    var layerOnClick = (0, react_1.useCallback)(function (event) {
        if (event.target === event.currentTarget) {
            closeMenuAndRestoreFocus();
        }
    }, [closeMenuAndRestoreFocus]);
    var menuOnKeyDown = (0, react_1.useCallback)(function (event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            closeMenuAndRestoreFocus();
            return;
        }
        if (event.key === 'Tab') {
            closeMenuAndRestoreFocus();
            return;
        }
        var items = Array.from(event.currentTarget.querySelectorAll('[role="menuitem"]'));
        var currentIndex = items.indexOf(document.activeElement);
        var nextIndex = event.key === 'ArrowDown'
            ? (currentIndex + 1) % items.length
            : event.key === 'ArrowUp'
                ? (currentIndex - 1 + items.length) % items.length
                : event.key === 'Home'
                    ? 0
                    : event.key === 'End'
                        ? items.length - 1
                        : null;
        if (nextIndex !== null && items.length > 0) {
            event.preventDefault();
            items[nextIndex].focus();
        }
    }, [closeMenuAndRestoreFocus]);
    var optionOnClick = (0, react_1.useCallback)(function (event) {
        var value = event.currentTarget.dataset.value;
        if (typeof value !== 'string')
            return;
        closeMenuAndRestoreFocus();
        onSelect({
            type: 'select',
            value: value,
            reactEvent: event,
            nativeEvent: event.nativeEvent
        });
    }, [closeMenuAndRestoreFocus, onSelect]);
    var portalContainer = (_c = (_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.closest('.route-container')) !== null && _c !== void 0 ? _c : document.body;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { ref: triggerRef, type: 'button', className: (0, classnames_1.default)(ActionMenu_less_1.default['trigger'], className, { 'active': open }), title: title, "aria-label": title, "aria-haspopup": 'menu', "aria-expanded": open, tabIndex: tabIndex, onClick: openMenu }, children),
        open ?
            (0, react_dom_1.createPortal)(react_1.default.createElement("div", { className: ActionMenu_less_1.default['layer'], onClick: layerOnClick },
                react_1.default.createElement("div", { ref: menuRef, className: ActionMenu_less_1.default['menu-container'], style: position !== null && position !== void 0 ? position : HIDDEN_MENU_STYLE, role: 'menu', "aria-label": title, onKeyDown: menuOnKeyDown }, options.map(function (option) {
                    var _a;
                    return (react_1.default.createElement("button", { key: option.value, type: 'button', className: ActionMenu_less_1.default['option-container'], title: (_a = option.title) !== null && _a !== void 0 ? _a : option.label, "data-value": option.value, role: 'menuitem', tabIndex: -1, onClick: optionOnClick },
                        react_1.default.createElement("span", { className: ActionMenu_less_1.default['label'] }, option.label)));
                }))), portalContainer)
            :
                null));
};
exports.default = ActionMenu;
